export default "/lineup-tool/assets/redux/times-dark.svg";